import React from 'react';
import PropTypes from 'prop-types';
import I18n from 'apps/new-web/views/components/i18n';
import Image from 'apps/new-web/views/components/image';
import ArrowBounce from 'apps/new-web/views/components/arrow-bounce';

const FusionHero = ({ registerUrl, loginUrl }) => {
  return (
    <div className="fusion-hero-component">
      <div className="fusion-hero-copy">
        <Image className="fusion-logo" src={ '/pages/fusion/components/img/new-fusion-logo.svg' } alt="" />
        <Image className="fusion-icon" src={ '/pages/fusion/components/img/fusion-icon.png' } alt="" />
        <h1><I18n args={{ 'fusion': 'NordicTrack Fusion CST' }}>Get started with the [fusion] app for your tablet.</I18n></h1>
        <a href={ registerUrl }><I18n>Create an account</I18n></a>
        <p className="or" aria-hidden="true"><I18n>or</I18n></p>
        <a href={ loginUrl }><I18n>Sign in to my account</I18n></a>
      </div>
      <ArrowBounce />
    </div>
  );
};

FusionHero.propTypes = {
  registerUrl: PropTypes.string.isRequired,
  loginUrl: PropTypes.string.isRequired
};

export default FusionHero;
